import { Component } from '@angular/core';
import { NavController, LoadingController } from 'ionic-angular';
import { Globals } from "../../../globals";
import { HttpClient } from '@angular/common/http';
import { ConfigurationPrintersWizardTypePage } from './configuration-printers-wizard/configuration-printers-wizard-type/configuration-printers-wizard-type';


@Component({
  selector: 'page-configuration-thermal-printers',
  templateUrl: 'configuration-thermal-printers.html'
})

export class ConfigurationThermalPrintersPage {

  list: any;

  constructor(public navCtrl: NavController,
    public globals: Globals,
    public http: HttpClient,
    public loadingCtrl: LoadingController) {

  }

  addPrinters() {
    this.navCtrl.push(ConfigurationPrintersWizardTypePage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-thermal-printers/configuration-thermal-printers.ts